import {NgModule} from '@angular/core';
import {InvestComponent} from './invest.component';
import {ContactUsModule} from '../../views/contact-us/contact-us.module';
import {JsonLdSchemaModule} from '../../json-ld-schema/json-ld-schema.module';
import {CommonSectionsModule} from '../../views/common/common-sections.module';
import {RbiDisclaimerModule} from '../../common/rbi-disclaimer/rbi-disclaimer.module';
import {CommonInvestSectionsModule} from '../common-invest-sections/common-invest-sections.module';
import { PosterComponent } from './finzy-flex/poster/poster.component';
import { NCashComponent } from './finzy-flex/nCash/nCash.component';
import { InvestmentSectionsModule } from './finzy-flex/invest-sections/investment-sections.module';

@NgModule({
    declarations: [InvestComponent, PosterComponent, NCashComponent],
    imports: [RbiDisclaimerModule, CommonInvestSectionsModule, CommonSectionsModule, JsonLdSchemaModule, ContactUsModule, InvestmentSectionsModule]
})
export class InvestModule {
}
